/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrintTerminalRequest
 */
export interface PrintTerminalRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintTerminalRequest
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof PrintTerminalRequest
     */
    xhtml: string;
}

/**
 * Check if a given object implements the PrintTerminalRequest interface.
 */
export function instanceOfPrintTerminalRequest(value: object): value is PrintTerminalRequest {
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('xhtml' in value) || value['xhtml'] === undefined) return false;
    return true;
}

export function PrintTerminalRequestFromJSON(json: any): PrintTerminalRequest {
    return PrintTerminalRequestFromJSONTyped(json, false);
}

export function PrintTerminalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintTerminalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
        'xhtml': json['xhtml'],
    };
}

export function PrintTerminalRequestToJSON(json: any): PrintTerminalRequest {
    return PrintTerminalRequestToJSONTyped(json, false);
}

export function PrintTerminalRequestToJSONTyped(value?: PrintTerminalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminalId': value['terminalId'],
        'xhtml': value['xhtml'],
    };
}

